import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type Props = {
  leadsByOrigin: { origin: string; count: number; companyName?: string }[];
  cityFilter?: string;
};

export function LeadsByOrigin({ leadsByOrigin, cityFilter }: Props) {
  const filteredLeads = leadsByOrigin.filter((lead) => {
    if (cityFilter === "TODAY") return true;
    return lead.companyName === cityFilter;
  });

  const groupedLeads = filteredLeads.reduce((acc, item) => {
    const origin = item.origin || "Não informado";
    
    if (acc[origin]) {
      acc[origin] += item.count;
    } else {
      acc[origin] = item.count;
    }
    
    return acc;
  }, {} as Record<string, number>);

  const sortedLeads = Object.entries(groupedLeads)
    .map(([origin, count]) => ({ origin, count }))
    .sort((a, b) => b.count - a.count);

  return (
    <Card className="w-1/2">
      <CardHeader>
        <CardTitle className="font-bold">Leads por Origem</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {sortedLeads.length > 0 ? (
            sortedLeads.map((item) => (
              <div 
                key={item.origin} 
                className="flex flex-col items-center justify-center p-4 border rounded-lg hover:shadow-md transition-shadow"
              >
                <p className="text-2xl font-bold text-black">{item.count}</p>
                <p className="text-sm text-center text-gray-500 font-bold mt-2">
                  {item.origin}
                </p>
              </div>
            ))
          ) : (
            <p className="col-span-full text-center text-gray-500 py-8">
              Nenhum lead por origem encontrado.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
